import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";

export const selectElement = (quantity: string, message: string): IAction => ({
  type: actionTypes.CHANGE_SELECTED_ITEMS,
  meta: { quantity: quantity, message: message },
});

export const hideSelection = (): IAction => ({
  type: actionTypes.HIDE_SELECTED_ITEMS,
});

export const refreshDashboard = (): IAction => ({
  type: actionTypes.REFRESH_DASHBOARD,
});

export const toggleViewsparkButton = (
  showViewsparkButton: boolean
): IAction => ({
  type: actionTypes.TOGGLE_VIEWSPARK_BUTTON,
  meta: { showViewsparkButton: showViewsparkButton },
});

export const messengerIsAvailable = (available: boolean): IAction => ({
  type: actionTypes.MESSENGER_OPTION,
  payload: available,
});
